let $ = window.jQuery

function rafAsync() {
    return new Promise(resolve => {
        requestAnimationFrame(resolve); //faster than set time out
    });
}

function checkElement(selector) {
    if (document.querySelector(selector) === null) {
        return rafAsync().then(() => checkElement(selector));
    } else {
        return Promise.resolve(true);
    }
}

$(document).ready(() => {
  console.log('before button')
	
const wait = () => {
  return new Promise((resolve, reject) => {
    setTimeout(() => {
               resolve(true)
               }, 777)
  })
}
  checkElement('.bndlr-add-to-cart').then(async (e) => {
                                          await wait();
    let btn = $('.bndlr-add-to-cart')
    btn.text('In den Warenkorb')
    btn.removeClass('bndlr-add-to-cart')
    btn.addClass('button button--primary bundle__button') 
    console.log('after button')
    
    // imgEl = $('#bundle__payment-icons')
    
    // const clone = imgEl.clone()
    // imgEl.remove()
	const el = $('.bndlr-product-options-container')
let cIdx = 0
let counts = 1
  })
})
